import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  '@keyframes breathe': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.6 },
  },
  stopButton: {
    animation: '$breathe 1.6s ease-in-out infinite',
    color: theme.palette.primary.main,
  },
  sendIcon: {
    minWidth: 20,
    paddingBlock: 4,
    paddingInline: 6,
  },
  input: {
    backgroundColor: theme.palette.background.paper,
  },
  linkColor: {
    color: theme.palette.primary.main,
  },
  feedbackLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    color: 'inherit',
    font: 'inherit',
    textDecoration: 'underline',
  },
}))

export default styles
